import ArrowDownward from "@mui/icons-material/ArrowDownward";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import React from "react";
import { COMPONENT_IDS } from "../../../../helpers/constants/componentIds";
import { DESC } from "../../MuiTable";
import { SortIconWrapper } from "./SortIcon.style";

interface SortIconProps {
  sortColumn: string | null;
  column: string;
  sortDirection: string;
}

export const SortIcon: React.FC<SortIconProps> = ({
  sortColumn,
  column,
  sortDirection,
}) => {
  let icon;
  if (sortColumn === column) {
    icon =
      sortDirection === DESC ? (
        <ArrowDownward
          className="table-header-icon"
          data-testid={COMPONENT_IDS.ARROW_DOWNWARD_ICON}
        />
      ) : (
        <ArrowUpward
          className="table-header-icon"
          data-testid={COMPONENT_IDS.ARROW_UPWARD_ICON}
        />
      );
  } else {
    icon = <SwapVertIcon className="table-header-icon swap-icon" />;
  }

  return <SortIconWrapper>{icon}</SortIconWrapper>;
};
